import React, { useEffect, useState } from 'react';

import { GetAppResult, getApps } from 'react-native-map-link';
import {
  Container,
  Content,
  HeaderCard,
  Footer,
  Item,
  ItemContainer,
  ItemList,
  ItemName,
  Label,
  ContentHeader,
  LogoImage,
  UnitInfos,
  State,
  Name,
} from './styles';
import {Header} from '../../../../../components/Interface/Headers/Header';
import {Titles} from '../../../../../components/Interface/Typographies/Titles';
import {useNavigation, useRoute} from '@react-navigation/native';
import {UnidadeDTO} from '../../../../../dtos/ParceiroDTO';
import {Icon} from '../../../../../components/Interface/Typographies/Icon';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Button} from '../../../../../components/Interface/Forms/Buttons/Button';

interface Params {
  data: UnidadeDTO;
  image: string;
}

export function UnitsDetails() {
  const navigation = useNavigation();
  const route = useRoute();

  const {data, image} = route.params as Params;
  const [maps, setMaps] = useState<GetAppResult[]>([] as GetAppResult[]);

  const LAT = parseFloat(data.endereco.geolocalizacao.latitude);
  const LNG = parseFloat(data.endereco.geolocalizacao.longitude);
  useEffect(() => {
    async function getMaps() {
      const apps = await getApps({
        appsWhiteList: ['waze', 'apple-maps', 'google-maps'],
        directionsMode: 'car',
        latitude: LAT,
        longitude: LNG,
      });

      setMaps(apps);
    }

    getMaps();
  }, []);

  type InfoItem = {
    key: string;
    icon: string;
    label: string;
    value: string;
    awesome5?: boolean;
  };

  const infoList: InfoItem[] = [
    data.telefones[0] && {
      key: 'phone',
      icon: 'phone',
      label: 'Telefone',
      value: data.telefones[0],
      awesome5: true,
    },
    data.endereco.estado.nome && {
      key: 'state',
      icon: 'map-marked-alt',
      label: 'Estado',
      value: data.endereco.estado.nome,
      awesome5: true,
    },
    data.endereco.cidade.nome && {
      key: 'city',
      icon: 'map-pin',
      label: 'Cidade',
      value: data.endereco.cidade.nome,
      awesome5: true,
    },
    data.endereco.resumo && {
      key: 'address',
      icon: 'building',
      label: 'Endereço',
      value: data.endereco.resumo,
      awesome5: true,
    },
  ].filter((item): item is InfoItem => Boolean(item));

  function handleOpenMap() {
    if (maps[0]?.open) {
      maps[0].open();
    }
  }

  return (
    <Container>
      <Header icon="chevron-left" action={() => navigation.goBack()} />

      <Content>
        <Titles title="Detalhes" subtitle="Informações da unidade" />

        <HeaderCard>
          <ContentHeader>
            <LogoImage source={{uri: image}} resizeMode="contain"
            style={{
              backgroundColor: '#fff',
              shadowOffset: {width: 0, height: 7},
              shadowOpacity: 0.2,
              shadowRadius: 6,
              elevation: 8,
            }}>
              </LogoImage>

            <UnitInfos>
              <State>{data.endereco.estado.nome}</State>
              <Name>{data.nome}</Name>
            </UnitInfos>
          </ContentHeader>
        </HeaderCard>

        <ItemList>
          {infoList.map((item, index) => (
            <Item
              key={item.key}
              style={{
                borderBottomWidth: index === infoList.length - 1 ? 0 : 1,
              }}>
              <Icon name={item.icon} awesome5={item.awesome5} />
              <ItemContainer>
                <Label>{item.label}</Label>

                <ItemName>{item.value}</ItemName>
              </ItemContainer>
            </Item>
          ))}
        </ItemList>
      </Content>
      <Footer>
        <SafeAreaView>
          <Button
            title="Ver rota"
            enabled={maps.length > 0}
            onPress={handleOpenMap}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
